// Display name mapping based on UserType enum from the HomeWebsite codebase:
// https://github.com/TrainingPeaks/HomeWebsite/blob/release/HomeWebsite.UI/Utilities/UserTypeExtensions.cs#L7
import {
  USER_TYPE_COACHED_ATHLETE,
  USER_TYPE_PREMIUM,
  USER_TYPE_BASIC,
} from "@constants/user";
import { User } from "@appTypes/index";

const USER_TYPE_DISPLAY_NAMES: Record<number, string> = {
  [USER_TYPE_COACHED_ATHLETE]: "Premium Coached Athlete",
  [USER_TYPE_PREMIUM]: "Premium Athlete",
  [USER_TYPE_BASIC]: "Free",
};

export const getUserTypeDisplayName = (userType?: User["userType"]): string | undefined => {
  if (userType === undefined) return undefined;
  return USER_TYPE_DISPLAY_NAMES[userType] ?? "Unspecified";
};
